import { render, staticRenderFns } from "./InvoiceNotificationResult.vue?vue&type=template&id=229c1f8d&lang=pug&"
import script from "./InvoiceNotificationResult.vue?vue&type=script&lang=ts&"
export * from "./InvoiceNotificationResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports